import React from 'react'
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Carregamento({ carregando }) {
    if (!carregando) return null
    
    return (
        <ModalContainer zIndex={100}>
            <ModalDialog className="nosso-modal modal-margin">
                <div className="text-center">
                    <h1>Aguarde por favor..</h1>
                    <FontAwesomeIcon icon="circle-notch" size={"2x"} className={"icone"} color={"#001C43"} spin />
                </div>
            </ModalDialog>
        </ModalContainer>
    )
}



// WEBPACK FOOTER //
// ./src/modules/desova-pier/components/Carregamento.js